/* Publish by EComposer at 2024-07-31 16:59:11*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8vfb1xi6cq5"]=  window.__ectimmers["ecom-8vfb1xi6cq5"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8vfb1xi6cq5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vfb1xi6cq5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8eafsycolb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8eafsycolb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yhq67p0wid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yhq67p0wid', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk3r8yebhqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk3r8yebhqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99g5ftmsceq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99g5ftmsceq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znuxa6166ag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znuxa6166ag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-le4mmj0fzrd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-le4mmj0fzrd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6v8of13o4fp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6v8of13o4fp', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mphprzny7oe"]=  window.__ectimmers["ecom-mphprzny7oe"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-mphprzny7oe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mphprzny7oe', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-laikm4gaoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-laikm4gaoi', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5b1jlmmr0zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5b1jlmmr0zr', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5kltlh9qzsw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5kltlh9qzsw', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b6i34t0fudg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b6i34t0fudg', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46skreekf9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46skreekf9e', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uyyyr0hsgsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uyyyr0hsgsb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 try{
 try{
 try{
 try{
 
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}